import { useStepper } from '@/hooks/useStepper';
import { DataModelAttribute, Item } from '@/types/DataModel';

import { MassUpdateAttributeValue } from '../mass-update.types';
import ChooseAttribute from './MassUpdateChooseAttributes';
import Summary from './MassUpdateSummary';
import UpdateAttributeValues from './MassUpdateUpdateAttributeValues';

interface StepsBuilderProps {
    category?: string;
    item: Item;
    values: Record<string, MassUpdateAttributeValue>;
    selectedAttributes: DataModelAttribute[];
    primaryKeys: string[] | undefined;
    handleSelectedAttributesChange: (selectedAttributes: DataModelAttribute[]) => void;
    setUpdatedValues: (values: Record<string, MassUpdateAttributeValue>) => void;
}

const StepsBuilder = ({
    primaryKeys,
    handleSelectedAttributesChange,
    item,
    selectedAttributes,
    setUpdatedValues,
    values,
    category
}: StepsBuilderProps) => {
    const { currentStep } = useStepper();
    switch (currentStep) {
        case 1:
            return (
                <ChooseAttribute
                    selectedAttributes={selectedAttributes}
                    item={item}
                    category={category}
                    handleSelectedAttributesChange={(selected) =>
                        handleSelectedAttributesChange(selected)
                    }
                />
            );
        case 2:
            return (
                <UpdateAttributeValues
                    selectedAttributes={selectedAttributes}
                    updatedValues={values}
                    setUpdatedValues={(nextValues) => setUpdatedValues(nextValues)}
                />
            );
        case 3:
            return (
                <Summary
                    selectedAttributes={selectedAttributes}
                    updatedValues={values}
                    primaryKeys={primaryKeys}
                />
            );
    }
};

export default StepsBuilder;
